import React from "react";
import {NotificationFeed} from "../components/NotificationFeed";
import type {NotificationScope} from "../components/notificationScope";

interface CabinetNotificationsPageProps {
  scope: NotificationScope;
  className?: string;
}

/** Вся история уведомлений кабинета; свежие видны в колокольчике шапки, настройки — в «Настройках». */
export function CabinetNotificationsPage({scope, className = ""}: CabinetNotificationsPageProps): JSX.Element {
  return (
    <div className={`page merchant-notify-page ${className}`}>
      <header className="page-header merchant-page-header">
        <div>
          <h1>Уведомления</h1>
          <p className="page-subtitle">
            Вся история событий по заявкам и балансу. Что присылать и куда — в{" "}
            <a href={scope.settingsRoute}>настройках</a>.
          </p>
        </div>
      </header>

      <section className="merchant-section-card" aria-label="Лента уведомлений">
        <NotificationFeed scope={scope} pageSize={30}/>
      </section>
    </div>
  );
}
